import React from 'react';
import { Link } from '@inertiajs/react';
import AuthLayout from '../../components/AuthLayout.jsx';

export default function InvitationShow({ invitation }) {
  const loginUrl = `/login?invitation_token=${invitation.token}&email=${encodeURIComponent(invitation.email)}`;
  const registerParams = new URLSearchParams({
    invitation_token: invitation.token,
    email: invitation.email,
  });
  if (invitation.first_name) registerParams.set('first_name', invitation.first_name);
  if (invitation.last_name) registerParams.set('last_name', invitation.last_name);
  if (invitation.student_type) registerParams.set('student_type', invitation.student_type);
  const registerUrl = `/register?${registerParams.toString()}`;

  return (
    <AuthLayout>
      <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="flex justify-center mb-6">
            <img src="/logo.png" alt="123CEU" className="h-12 w-auto" />
          </div>
          <h2 className="mt-2 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
            You've been invited
          </h2>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-6 mb-6">
            <h3 className="text-lg font-semibold text-gray-900">{invitation.facility_name}</h3>
            <p className="text-sm text-gray-600 mt-1">{invitation.facility_type_display}</p>
            <p className="text-sm text-gray-600 mt-2">
              You've been invited as <span className="font-medium capitalize">{invitation.role}</span>
            </p>
            <p className="text-sm text-gray-500 mt-1">
              Invitation sent to <span className="font-medium">{invitation.email}</span>
            </p>
          </div>

          <p className="text-center text-sm text-gray-600 mb-6">
            Sign in or create an account to accept this invitation.
          </p>

          <div className="space-y-3">
            <Link
              href={loginUrl}
              className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-indigo-700"
            >
              Sign in to accept
            </Link>
            <Link
              href={registerUrl}
              className="flex w-full justify-center rounded-md border border-gray-300 bg-white px-3 py-2.5 text-sm/6 font-semibold text-gray-900 shadow-sm hover:bg-gray-50"
            >
              Create an account
            </Link>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}
